import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { renderTrustedMarkdown } from '~/functions/markdown'


export default /*#__PURE__*/_defineComponent({
  __name: 'GhgGrowthFactorIntro',
  props: {
    ghgSavingPotentialData: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { ghgSavingPotentialData: Record<string, any> };



const ghgSavingPotentialId = computed(() => props.ghgSavingPotentialData?.id)
const comparativeUnit = computed(() => props.ghgSavingPotentialData?.comparativeUnit)

return { __sfc: true,props, ghgSavingPotentialId, comparativeUnit, renderTrustedMarkdown }
}

})